module.exports = __webpack_public_path__ + "static/img/successDetail1Fu.eb2f1a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/successDetail1Fu.png
// module id = 0023
// module chunks = 2